import React from 'react'

export default function Cancel() {
    return (
        <div className='text-center p-24 text-2xl font-bold'>
            Payment Cancel
        </div>
    )
}
